import type { Game } from 'chessboard/model/game/types';

/**
 * A semantically-named util to determine if the given node is the on the first line in its parent's lines array
 */
export function isOnFirstLineOfParentNode(
  node: Game.Move.Node,
  parentNode: Game.Move.Node,
): boolean {
  return parentNode.lines ? node.ids.line === parentNode.lines[0] : false;
}
